export * from './GettingStartedNoCookingFooter';
export * from './GettingStartedMealsEveryWeekFooter';
export * from './GettingStartedHealthyQuickEasyFooter';
export * from './GettingStartedPauseSkipAnytimeFooter';
export * from './GettingStartedTooMuchOnPlateFooter';
